import { CaseWhenItem } from "../contexts";
import { isObjectRecord } from "./isObjectRecord";
import { isWhereClause } from "./isWhereClause";

/**
 * Type guard to check if a value is a CaseWhenItem.
 *
 * Validates that the object has the required properties of a CaseWhenItem:
 * - id: string
 * - thenDisplayPattern: T
 * - thenResultPattern: string
 * - thenVariables: AnnotationVariable[] (each element passes isAnnotationVariable)
 * - type: "display" | "result"
 * - when: WhereClause
 *
 * @param obj - The value to check.
 * @param isT - Type guard function for the generic type T.
 * @returns True if the value is a CaseWhenItem.
 */
export const isCaseWhenItem = <T>(
  obj: unknown,
  isT: (obj: unknown) => obj is T,
): obj is CaseWhenItem<T> => {
  if (!isObjectRecord(obj)) return false;

  if (typeof obj.id !== "string") return false;
  if (!isT(obj.thenDisplayPattern)) return false;
  if (typeof obj.thenResultPattern !== "string") return false;
  if (obj.when !== null && !isWhereClause(obj.when)) return false;

  // Everything is good
  return true;
};
